module.exports = __webpack_public_path__ + "assets/img/block-right-b2c4289a.png";